/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSpinResult.vue?vue&type=template&id=50163080&scoped=true"
import script from "./popSpinResult.vue?vue&type=script&lang=js"
export * from "./popSpinResult.vue?vue&type=script&lang=js"
import style0 from "./popSpinResult.vue?vue&type=style&index=0&id=50163080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50163080",
  null
  
)

export default component.exports